/** Customer-facing portal URL for a ticket (same origin as POS web app). */
export function buildTicketPortalUrl(portalToken: string): string {
  return `${window.location.origin}/portal/t/${portalToken}`;
}

export function copyTicketPortalLink(portalToken: string): Promise<void> {
  return navigator.clipboard.writeText(buildTicketPortalUrl(portalToken));
}

export function openPortalSmsCompose(phone: string, portalToken: string): void {
  const url = buildTicketPortalUrl(portalToken);
  const body = encodeURIComponent(`Track your repair: ${url}`);
  const digits = phone.replace(/\D/g, '');
  window.open(`sms:${digits}?body=${body}`, '_self');
}
